import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "subheader" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "subheader-icon fal fa-users" }, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = { class: "panel-hdr mt-2" }
const _hoisted_9 = { class: "float-left" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus-square" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-sm-block float-right ml-1" }, "Nueva entrada", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus-square" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-sm-block float-right ml-1" }, "Nueva salida", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "fw-300" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-collapse",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Collapse"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-fullscreen",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Fullscreen"
  })
], -1)
const _hoisted_18 = { class: "panel-container" }
const _hoisted_19 = { class: "panel-content" }
const _hoisted_20 = { class: "row mb-2" }
const _hoisted_21 = { class: "col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "input-group" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" })
  ])
], -1)
const _hoisted_25 = { class: "col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-excel" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-sm-inline ml-1" }, "Descargar Excel", -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "text-right" }
const _hoisted_33 = { class: "text-right" }
const _hoisted_34 = { class: "text-right" }
const _hoisted_35 = { class: "text-right" }
const _hoisted_36 = { class: "text-right" }
const _hoisted_37 = { class: "text-right" }
const _hoisted_38 = { class: "text-right" }
const _hoisted_39 = { class: "text-right" }
const _hoisted_40 = { class: "text-right" }
const _hoisted_41 = { class: "text-right" }
const _hoisted_42 = { class: "text-right" }
const _hoisted_43 = { class: "text-right" }
const _hoisted_44 = { class: "text-right" }
const _hoisted_45 = { class: "text-right" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", {
  class: "page-content-overlay",
  "data-action": "toggle",
  "data-class": "mobile-nav-on"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_kardex_editar_entrada_salida_component = _resolveComponent("kardex-editar-entrada-salida-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm mr-2",
                  title: "Nueva entrada",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.nuevaEntrada && $setup.nuevaEntrada(...args)))
                }, _hoisted_12),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-success btn-sm mr-2",
                  title: "Nueva salida",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.nuevaSalida && $setup.nuevaSalida(...args)))
                }, _hoisted_15)
              ]),
              _createElementVNode("h2", null, [
                _createTextVNode(" Listado de"),
                _createElementVNode("span", _hoisted_16, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
                ])
              ]),
              _hoisted_17
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "texto-buscar",
                          name: "texto-buscar",
                          class: "form-control form-control-sm flex",
                          placeholder: "Buscar",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.textoFiltro) = $event)),
                          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.onSearch && $setup.onSearch(...args)))
                        }, null, 544), [
                          [_vModelText, $setup.textoFiltro]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        id: "fecha-filtro",
                        name: "fecha-filtro",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.fechaFiltro) = $event)),
                        onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.onFechaChange && $setup.onFechaChange(...args)))
                      }, null, 544), [
                        [_vModelText, $setup.fechaFiltro]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-success btn-sm",
                      title: "Descargar Excel",
                      disabled: !$setup.fechaFiltro,
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.descargarExcel && $setup.descargarExcel(...args)))
                    }, _hoisted_31, 8, _hoisted_28)
                  ])
                ]),
                (!$setup.fechaFiltro)
                  ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                      key: 0,
                      "server-options": $setup.serverOptions,
                      "onUpdate:serverOptions": _cache[7] || (_cache[7] = ($event: any) => (($setup.serverOptions) = $event)),
                      "server-items-length": $setup.totalItems,
                      loading: $setup.loading,
                      headers: $setup.headers,
                      items: $setup.kardexs,
                      "border-cell": "",
                      alternating: "",
                      "buttons-pagination": ""
                    }, {
                      "item-saldo_inicial": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_32, _toDisplayString($setup.numeral(item.saldo_inicial).format('0,0.00')), 1)
                      ]),
                      "item-entradas": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_33, _toDisplayString($setup.numeral(item.entradas).format('0,0.00')), 1)
                      ]),
                      "item-salidas": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_34, _toDisplayString($setup.numeral(item.salidas).format('0,0.00')), 1)
                      ]),
                      "item-saldo": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_35, _toDisplayString($setup.numeral(item.saldo).format('0,0.00')), 1)
                      ]),
                      "item-valor_entradas": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_36, _toDisplayString($setup.numeral(item.valor_entradas).format('0,0.00')), 1)
                      ]),
                      "item-costo_salidas": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_37, _toDisplayString($setup.numeral(item.costo_salidas).format('0,0.00')), 1)
                      ]),
                      "item-valor_saldo": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("strong", null, _toDisplayString($setup.numeral(item.valor_saldo).format('0,0.00')), 1)
                        ])
                      ]),
                      "item-ingreso_ventas": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_39, _toDisplayString($setup.numeral(item.ingreso_ventas).format('0,0.00')), 1)
                      ]),
                      "item-costo_ventas": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_40, _toDisplayString($setup.numeral(item.costo_ventas).format('0,0.00')), 1)
                      ]),
                      "item-utilidad_bruta": _withCtx((item) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["text-right", item.utilidad_bruta >= 0 ? 'text-success' : 'text-danger'])
                        }, [
                          _createElementVNode("strong", null, _toDisplayString($setup.numeral(item.utilidad_bruta).format('0,0.00')), 1)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["server-options", "server-items-length", "loading", "headers", "items"]))
                  : (_openBlock(), _createBlock(_component_EasyDataTable, {
                      key: 1,
                      headers: $setup.headersDetalle,
                      items: $setup.movimientosDia,
                      loading: $setup.loading,
                      "border-cell": "",
                      alternating: "",
                      "buttons-pagination": ""
                    }, {
                      "item-concepto": _withCtx((item) => [
                        _createTextVNode(_toDisplayString($setup.descripcionConcepto(item.concepto)), 1)
                      ]),
                      "item-tipo_movimiento": _withCtx((item) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", item.tipo_movimiento === 'entrada' ? 'badge-success' : 'badge-danger'])
                        }, _toDisplayString(item.tipo_movimiento === 'entrada' ? 'Entrada' : 'Salida'), 3)
                      ]),
                      "item-movimiento": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_41, _toDisplayString($setup.numeral(item.movimiento).format('0,0.00')), 1)
                      ]),
                      "item-precio_costo_unitario": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_42, _toDisplayString($setup.numeral(item.precio_costo_unitario).format('0,0.00')), 1)
                      ]),
                      "item-costo_total": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_43, _toDisplayString($setup.numeral(item.costo_total).format('0,0.00')), 1)
                      ]),
                      "item-saldo_unidades": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_44, _toDisplayString($setup.numeral(item.saldo_unidades).format('0,0.00')), 1)
                      ]),
                      "item-saldo_valor": _withCtx((item) => [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("strong", null, _toDisplayString($setup.numeral(item.saldo_valor).format('0,0.00')), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["headers", "items", "loading"]))
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_46,
    _createVNode(_component_kardex_editar_entrada_salida_component, {
      ref: "kardexEditarEntradaSalidaComponentRef",
      onCerrarKardexEditarEntradaSalidaComponent: $setup.cerrarKardexEditarEntradaSalidaComponentEmit
    }, null, 8, ["onCerrarKardexEditarEntradaSalidaComponent"])
  ], 64))
}